import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

// Drop inside <tbody> to replace a spinner row while data loads.
// cols should match the table's column count.
const TableSkeleton = ({ cols = 4, rows = 6 }) => (
  <>
    {Array.from({ length: rows }).map((_, i) => (
      <tr key={i}>
        {Array.from({ length: cols }).map((_, j) => (
          <td key={j} style={{ padding: "8px 12px" }}>
            <Skeleton height={28} borderRadius={6} />
          </td>
        ))}
      </tr>
    ))}
  </>
);

export default TableSkeleton;
